/* Standish Milling redesigned site: product tabs, quick add to cart, toast. Search lives in smc-search.js.
   Plain JS, no libraries, loaded with `defer`. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* -------------------------------------------------------------------- tabs */
  function initTabs(root) {
    var tabs = $$('[role="tab"]', root);
    if (!tabs.length) return;
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var j = -1;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j > -1) { e.preventDefault(); select(tabs[j], true); }
      });
    });
  }

  /* ------------------------------------------------------------ add to cart */
  function updateCart(cart) {
    var total = new Intl.NumberFormat(undefined, { style: 'currency', currency: cart.currency || 'USD' }).format((cart.total_price || 0) / 100);
    $$('[data-smc-cart-total]').forEach(function (n) { n.textContent = total; });
    $$('[data-smc-cart-count]').forEach(function (n) {
      n.textContent = cart.item_count;
      n.hidden = !cart.item_count;
    });
  }

  var toastTimer;
  function toast(text, links) {
    var t = $('[data-smc-toast]');
    if (!t) return;
    t.textContent = text;
    (links || []).forEach(function (l) {
      t.appendChild(document.createTextNode(' '));
      var a = el('a', null, l[0]); a.href = l[1]; t.appendChild(a);
    });
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 5000);
  }

  function initAddToCart() {
    window.smcUpdateCart = updateCart;
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-smc-add]');
      if (!form || !window.fetch) return; // no fetch: the plain POST to /cart/add still works
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var labelEl = form.querySelector('[data-smc-submit-label]') || btn;
      var label = labelEl.textContent;
      var qtyEl = form.elements.quantity;
      var qty = Math.max(1, (qtyEl && parseInt(qtyEl.value, 10)) || 1);
      var err = form.querySelector('[data-smc-error]');
      if (err) err.hidden = true;
      btn.disabled = true;
      labelEl.textContent = 'Adding...';
      var failed = false;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(form.elements.id.value, 10), quantity: qty }] })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
        .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCart(cart);
          labelEl.textContent = 'Added';
          toast('Added to cart.', [['View cart', '/cart'], ['Check out', '/checkout']]);
        })
        .catch(function (e2) {
          failed = true;
          labelEl.textContent = 'Try again';
          if (err) { err.hidden = false; err.textContent = e2.message; }
        })
        .then(function () { setTimeout(function () { btn.disabled = false; labelEl.textContent = label; }, failed ? 2500 : 1600); });
    });
  }

  /* -------------------------------------------------------------------- boot */
  function boot() {
    $$('[data-smc-tabs]').forEach(initTabs);
    initAddToCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
